<template>
<div>
  <header-page :style="isCiudadano? 'display: none': ''" showCiudadSelector @update="ActionGetAueObjectives()" />
  <div
    :class="[
      'container aue-container',
      showIndicadores ? 'aue-container-indicadores' : '',
    ]"
  >
    <Breadcrumbs :visible="!isCiudadano" />
    <div class="row">
      <div class="title-container col-10" :style="isCiudadano?'padding-top: 25px;':'padding-top: 0px'">
          <q-img
            :src="require(`@/assets/img/agendaurbana.png`)"
            class="Imagen"
            width="85px"
            height="85px"
            contain
          />
          <div class="divTitle">
            <h5 v-if="!isCiudadano" class="title">Vista General</h5>
            <h5 v-if="isCiudadano" class="title">Vista General. {{ this.ciudadSelected.name }}</h5>
          </div>
      </div>
      <div class="col-2 divBtnPlanAccion">
        <q-btn
          v-if="!isCiudadano"
          unelevated
          class="bPrincipal"
          @click="openURL"
        >PLAN DE ACCIÓN</q-btn>
      </div>
    </div>
    <div class="row col-12">
      <div
        :class="['q-col-gutter-sm', showIndicadoresClass]"
        :style="styleShowIndicadoresClass"
      >
        <div :class="showIndicadoresClassItems">
          <div
            class="box-container col-sm-12 col-md-6"
            v-for="i in 5"
            v-bind:key="i"
          >
            <Contenedor
              :datos="aue[i - 1]"
              :showConsecucionObjetivo="false"
              :ciudadIndice="getCityData(aue[i - 1])"
              v-on:activeObjetivo="activarObjetivo($event)"
              @updateVisibility="refreshObjetivoVisibility"
            />
          </div>
        </div>
        <div :class="showIndicadoresClassItems">
          <div :class="['container-objetivos']">
            <div
              class="box-container col-sm-12 col-md-6"
              v-for="i in 5"
              v-bind:key="i"
            >
              <Contenedor
                :datos="aue[i + 4]"
                :ciudadIndice="getCityData(aue[i + 4])"
                v-on:activeObjetivo="activarObjetivo($event)"
                @updateVisibility="refreshObjetivoVisibility"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-7 container-indicadores">
        <ListadoIndicadores
          v-model="showIndicadores"
          :indicadores="indicadores"
          @close="delayAnimationWidth()"
        />
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Utils from '@/components/shared/helpers/Utils.js';
import Contenedor from '@/components/Aue/components/Objetivo.vue';
import Message from '@/components/shared/mixins/Message.js';
import ListadoIndicadores from '@/components/Indicadores/components/Listado.vue';
import { QImg } from 'quasar';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import Const from '@/components/shared/helpers/Const.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Vue from 'vue';

export default {
  mixins: [Message, Loading],
  components: {
    Contenedor,
    ListadoIndicadores,
    HeaderPage,
    QImg,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      aue: types.ALL_AUEOBJETIVES,
      aueCity: types.AUEOBJETIVE_CIUDAD,
      AUESelected: types.AUE_SELECTED,
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  data () {
    return {
      showIndicadores: false,
      showIndicadoresClass: 'row col-12',
      styleShowIndicadoresClass: 'display: flex; justify-content: space-between',
      showIndicadoresClassItems: 'col-md-5 col-xs-12',
      objetivos: [],
      indicadores: [],
      objetivoSelected: null,
      arrayIndicadoresAdd: [],
      resolutionMobile: Const.RESOLUTION_MOBILE
    };
  },
  async created () {
    if (this.ciudadSelected !== null) {
      if (this.ciudadSelected.indices.indexOf(Const.ID_AUE) === -1) {
        this.$router.push({ name: 'inicio' });
      }

      // Empty State of AUE Selected
      this.$store.commit(types.MUTATE_AUE_SELECTED, null);
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_AUEOBJETIVES).then(async response => {
        this.ActionGetAueObjectives(); this.hideLoading();
      }).catch(() => { this.hideLoading(); });
    }
  },
  watch: {
    ciudadSelected () {
      if (this.ciudadSelected.indices.indexOf(Const.ID_AUE) === -1) this.$router.push({ name: 'inicio' });
    }
  },
  async mounted () {
    // Borramos la seleccción
    this.removeSelected();
    // Escuchamos desde metas
    this.$eventHub.$on('open_indicadores', (o) => {
      if (!this.resolutionMobile.matches) {
        this._goToTop();
        this.$store.state.NGUD.Aue.selected = o.param;

        this.showLoading();
        this.arrayIndicadoresAdd = [];
        this.getDataTarjetaIndicadores(o.param).then(() => {
          o.done(true);
        });
      }
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('open_indicadores');
  },
  methods: {
    _goToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    removeSelected () {
      this.$store.state.NGUD.Aue.selected = {};
      this.$store.commit(types.MUTATE_AUE_SELECTED, null);
    },
    async ActionGetAueObjectives () {
      this.delayAnimationWidth();
      this.removeSelected();
      await this.$store.dispatch(types.ACTION_GET_AUEOBJETIVE_CIUDAD).then().catch();
    },
    delayAnimationWidth () {
      setTimeout(() => {
        this.showIndicadoresClass = 'row col-12';
        this.styleShowIndicadoresClass = 'display: flex; justify-content: space-between';
        this.showIndicadoresClassItems = 'col-md-5 col-xs-12';
      }, 700);
      this.showIndicadores = false;
    },
    changeOrder (idObjetivo) {
      const index = this.aue.findIndex(e => e.id === idObjetivo);
      const aux = Utils.moveArray(this.aue, index, 0);
      this.orderObjetivos(aux);
    },
    activarObjetivo (selectedId) {
      if (selectedId !== this.AUESelected && this.AUESelected !== null) this.delayAnimationWidth();
      if (selectedId === this.AUESelected) return this.$store.commit(types.MUTATE_AUE_SELECTED, null);
      this.$store.commit(types.MUTATE_AUE_SELECTED, selectedId);
      this._goToTop();
      this.changeOrder(selectedId);
    },
    getCityData (dataObjetivo) {
      let returnData = {};
      let idObjetivo = dataObjetivo.id;

      this.aueCity.forEach(e => {
        if (e.id === idObjetivo) returnData = e;
      });
      return returnData;
    },
    refreshObjetivoVisibility (data) {
      this.aueCity.map((n) => { if (n.id === data.idObj) { n.visible = data.visibility; } });
    },
    orderObjetivos (data) {
      // Nos guardamos el primer valor para no ordenarlo.
      let auxFirstElement = data[0];
      data.splice(0, 1);
      let sortData = data;

      sortData.sort((a, b) => {
        return a.order - b.order;
      });

      sortData.splice(0, 0, auxFirstElement);

      return sortData;
    },
    openURL () {
      this.$router.push({
        name: 'vista-general/plan-accion'
      });
    },
    async getDataTarjetaIndicadores (o) {
      let arrayIndicadores = [];
      await this.$store.dispatch(types.ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO_TARJETASINDICADORESACCIONES, { idCiudad: this.ciudadSelected.id, idObjetivoEspecifico: o.metaId })
        .then(response => {
          arrayIndicadores = new Promise((resolve, reject) => {
            response.forEach(async (indicador) => {
              await this.fillIndicadores(indicador);
            });
            resolve(response);
          });
          arrayIndicadores.then((val) => {
            this.hideLoading();
            this.indicadores = [...val];
            if (this.indicadores.length > 0) {
              this.showTarjetaIndicadores();
            } else {
              this.delayAnimationWidth();
            }
          });
        }).catch(() => {
          this.hideLoading();
        });
    },
    async fillIndicadores (indicador) {
      if (indicador.tipo === 'Cualitativo' || indicador.tipo === 'Cuantitativo') {
        this.arrayIndicadoresAdd.push(indicador);
      } else {
        await this.getDataGraficaIndicador(indicador);
      }
      return this.arrayIndicadoresAdd;
    },
    async getDataGraficaIndicador (indicador) {
      await this.$store.dispatch(types.ACTION_GET_INDICADOR_TARJETA, { idCiudad: this.ciudadSelected.id, idIndicador: indicador.idIndicador })
        .then(response => {
          Vue.set(indicador, 'tarjeta', response);
          this.arrayIndicadoresAdd.push(indicador);
        }).catch(() => {
        });
    },
    showTarjetaIndicadores () {
      this.showIndicadoresClass = 'col-5';
      this.styleShowIndicadoresClass = '';
      this.showIndicadoresClassItems = 'col-12';
      this.showIndicadores = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.bPrincipal{
  float: right;
}
.divTitle{
  display: flex;
  justify-content: center;
}
.divBtnPlanAccion{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.aue-container-indicadores {
  padding-right: 33px !important;
  transition: padding 1s;
}
.aue-container {
  transition: padding 1s;
  color: #003f87;
  font-family: DINPro;
  .title-city {
    padding-top: 40px;
    font-family: DINPro;
    font-size: 35px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -1.41px;
    color: #002f6c;
  }
  .title-container {
    display: flex;
    padding-bottom: 25px;
    .title {
      padding-left: 10px;
      margin: auto;
      text-transform: uppercase;
      font-family: DINPro;
      font-size: 29px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -1.17px;
      color: #042857;
    }
  }
  padding-right: 100px;
  .box-container {
    padding-bottom: 40px;
  }

  .container-indicadores {
    padding-left: 36px;
  }
}

@media screen and (max-width: 599px) {
  .aue-container {
    padding: 0;
    margin-left: 10px;
    .box-container {
      padding-right: 8px;
    }
    .title {
      font-size: 26px;
    }
  }
}

@media screen and (max-width: 440px) {
  .aue-container {
    .box-container {
      margin-left: 0px;
      margin-right: 0px;
      padding-right: 0px;
      padding-left: 0px;
    }
  }
}

@media (max-width: 640px) {
  .box-container {
    padding-bottom: 0px !important;
  }
  .divTitle> h5 {
    font-size: 16px !important;
  }
  .Imagen{
    height: 45px !important;
    width: 45px !important;
  }
  .title-container {
    padding-bottom: 0px !important;
  }
}
</style>
